<template>
  <VueOwlCarousel
    v-if="stackList.length"
    ref="carousel"
    :key="'carousel-stack'"
    class="carousel__stack-container container__stacks"
    :nav="false"
    :responsive-refresh-rate="100"
    :auto-height="true"
    :responsive="{
      0: { items: 2, margin: 8 },
      576: { items: 2, margin: 8 },
      768: { items: 2, margin: 25 },
      992: { items: 3, margin: 38 }
    }"
  >
    <router-link
      v-for="(stack, index) in stackList"
      :key="`${stack.id}-${index}`"
      :to="{
        name: 'stack-detail',
        params: { stackId: stack.id }
      }"
    >
      <StackCard class="card__stack" :item="stack" />
    </router-link>
    <template slot="prev">
      <span class="prev icon__owl-nav icon__owl-prev">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(0,0,0,1)">
          <path
            d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"
          ></path>
        </svg>
      </span>
    </template>

    <template slot="next">
      <span class="next icon__owl-nav icon__owl-next">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(0,0,0,1)">
          <path
            d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"
          ></path>
        </svg>
      </span>
    </template>
  </VueOwlCarousel>
</template>

<script>
import StackCard from '@/views/Stack/components/StackCard.vue';

import layerCardSvg from '@/assets/stack-card/layer-card.svg';
import iconBadgeSvg from '@/assets/stack-card/icon-badge.svg';
import iconCertificateSvg from '@/assets/stack-card/icon-certificate.svg';
import defaultCoverImage from '@/assets/default-lu-cover.jpg';

export default {
  name: 'StackCarousel',

  components: {
    StackCard
  },

  props: {
    stackList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      layerCardSvg,
      iconBadgeSvg,
      iconCertificateSvg,
      defaultCoverImage
    };
  }
};
</script>

<style lang="scss" scoped>
.carousel__stack-wrapper {
  width: 100%;
  max-width: 100%;
  padding: 0 8px;
}

.carousel__stack-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel__stack-item {
  background: #ffffff;
  color: #070919;
  border-radius: 10px;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: transparent;
}

.badge__stack-overlay {
  padding: 0 4px;
  color: #3c44b1;
  background-color: #ffffff;
  font-weight: 700;
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 1;
  border-radius: 4px;

  .icon__stack-set {
    width: 10px;
    margin-right: 4px;
  }

  span {
    font-size: 10px;
  }
}

.icon__owl-nav {
  background: #ffffff;
  padding: 4px;
  box-shadow: 0px 4px 12px 0px #a6a6b94d;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 40%;

  z-index: 10;

  svg {
    width: 24px;
  }
}

.icon__owl-prev {
  transform: translateX(-45%);
}

.icon__owl-next {
  transform: translateX(-55%);
}

.carousel__stack-overlay {
  margin-bottom: -14px;
}

.stack-content__body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 8px;
  margin-bottom: 8px;
}

.stack-content__footer {
  height: 62px;
  border-top: 1px solid #d1d2db;
  padding-top: 8px;

  p {
    font-size: 12px;
  }
}

::v-deep .owl-carousel {
  display: grid;
}

::v-deep .stack__thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

::v-deep .owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #3c44b1;
}

::v-deep .owl-stage-outer {
  padding: 10px 0;
}

::v-deep .owl-stage {
  display: flex;
  align-items: stretch;
}

::v-deep .owl-item {
  height: auto;
  background: transparent;
}

::v-deep .anchor {
  display: none;
}

::v-deep .owl-theme .owl-nav.disabled + .owl-dots {
  margin-top: 20px;
}

@media screen and (min-width: 768px) {
  .carousel__stack-wrapper {
    padding: 0 20px;
  }

  .icon__owl-nav {
    padding: 10px;

    svg {
      width: 40px;
    }
  }

  .badge__stack-overlay {
    padding: 6px 8px;
    .icon__stack-set {
      width: 18px;
    }
    span {
      font-size: 16px;
    }
  }

  ::v-deep {
    .owl-stage {
      min-height: 547px;
    }
    .owl-theme .owl-nav.disabled + .owl-dots {
      margin-top: 40px;
    }
  }
}
</style>
